import React from 'react';
import PatientListTable from './PatientListTable';

export default function PatientsTab({ allPatients }) {
  return <PatientListTable patients={allPatients} showSearch />;
}
